import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var AppleDark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M15.475 43.999a5.836 5.836 0 0 0 2.368-.448c.665-.307 1.369-.614 2.111-.909a7.678 7.678 0 0 1 2.803-.448 7.115 7.115 0 0 1 2.751.435l1.997.883a5.925 5.925 0 0 0 2.47.448 4.672 4.672 0 0 0 2.675-.806 9.635 9.635 0 0 0 2.2-2.035c.68-.832 1.28-1.702 1.959-2.56a21.488 21.488 0 0 0 1.715-2.956c.361-.75.682-1.518.96-2.303v-.18l.14-.422.128-.397s-.37-.179-.96-.499a11.302 11.302 0 0 1-2.047-1.51 9.214 9.214 0 0 1-2.01-2.738 9.113 9.113 0 0 1-.857-4.147 9.227 9.227 0 0 1 .678-3.673c.398-.928.933-1.79 1.587-2.56a11.515 11.515 0 0 1 1.638-1.535l.845-.602a9.663 9.663 0 0 0-5.004-3.839 11.085 11.085 0 0 0-2.265-.5c-.653 0-1.139-.089-1.446-.089a9.433 9.433 0 0 0-3.11.5c-.947.345-1.817.678-2.56 1.01a5.258 5.258 0 0 1-2.047.512 5.12 5.12 0 0 1-2.022-.486c-.73-.32-1.536-.64-2.38-.947a7.758 7.758 0 0 0-2.74-.473 10.24 10.24 0 0 0-5.272 1.497 11.225 11.225 0 0 0-4.147 4.402 14.474 14.474 0 0 0-1.625 7.167c0 1.797.21 3.588.627 5.337A28.88 28.88 0 0 0 6.3 34.247a25.337 25.337 0 0 0 2.316 4.197 37.883 37.883 0 0 0 3.213 3.942A4.813 4.813 0 0 0 15.475 44Zm6.975-33.85a6.95 6.95 0 0 0 3.16-.87 8.958 8.958 0 0 0 2.79-2.227 10.687 10.687 0 0 0 1.677-2.854 8.714 8.714 0 0 0 .64-3.302c.006-.3-.015-.6-.064-.896a8.37 8.37 0 0 0-3.48 1.011 9.663 9.663 0 0 0-2.983 2.355 10.572 10.572 0 0 0-1.676 2.649 7.68 7.68 0 0 0-.742 3.289 2.882 2.882 0 0 0 0 .486v.32c.224.03.45.043.678.039Z",
    svgColor: "#302C41"
  }));
});
AppleDark.displayName = 'AppleDark';
AppleDark.defaultProps = {
  'aria-label': 'AppleDark'
};
export default AppleDark;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/AppleDark.js
// module id = 2943
// module chunks = 11